/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
import IconAngleBottom from '@assets/icons/angle-bottom.svg?react';
import IconMeter from '@assets/icons/meter.svg?react';
import IconMoon from '@assets/icons/moon.svg?react';
import IconNav from '@assets/icons/nav.svg?react';
import IconSearch from '@assets/icons/search.svg?react';
import IconSun from '@assets/icons/sun.svg?react';
import IconSettings from '@assets/icons/settings.svg?react';
import {
 AppBar,
 Avatar,
 Box,
 Button,
 IconButton,
 TextField,
 Theme,
 Toolbar,
 useColorScheme,
 useTheme,
} from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import buildversion from '../../../buildversion?raw';

import layoutSizes from '../../utils/layoutSizes';
import { identityLogoutStart } from '../../redux/identity/identitySlice';
import { useAuthContext } from '../../contexts/AuthContext';
import UserProfileModal from './UserProfileModal';
import UserPopover from './UserPopover';

const Search = () => {
 const { t } = useTranslation();
 const theme = useTheme();
 return (
  <Box
   sx={{
    position: 'relative',
    display: { xs: 'none', md: 'block' },
   }}
  >
   <TextField size="small" placeholder={t('global.search')} />
   <Box
    sx={{
     position: 'absolute',
     top: '50%',
     right: '8px',
     pointerEvents: 'none',
     transform: 'translateY(-50%)',
     background: theme.palette.kemek.bg2,
     width: '24px',
     height: '24px',
     display: 'inline-flex',
     alignItems: 'center',
     justifyContent: 'center',
    }}
   >
    <IconSearch
     style={{
      color: theme.palette.kemek.lightGray,
      display: 'block',
      width: '13.516px',
      height: '13.516px',
     }}
    />
   </Box>
  </Box>
 );
};

const ScalesWidget = () => (
 <Box
  sx={{
   display: 'flex',
   alignItems: 'center',
   ml: 'auto',
   gap: 1,
   p: 1,
   borderRadius: '16px',
   lineHeight: '18px',
   border: (theme: Theme) => `1px solid ${theme.palette.kemek.lightGray}`,
   fontWeight: 500,
   height: 32,
   pr: '4px',
  }}
 >
  <Box
   sx={{
    color: (theme: Theme) => theme.palette.kemek.lightGray,
    fontSize: 12,
   }}
  >
   Svarstyklės 1
  </Box>
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: (theme: Theme) => theme.palette.kemek.white,
    background: (theme: Theme) => theme.palette.kemek.lightGray,
    textAlign: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '24px',
    lineHeight: '24px',
    fontSize: 16,
    fontWeight: 500,
   }}
  >
   0
  </Box>
 </Box>
);

const UserWidget = () => {
 const { i18n } = useTranslation();
 const dispatch = useDispatch();
 const languages = i18n?.options?.resources;
 const [profileModalOpen, setProfileModalOpen] = useState(false);
 const [avatarAnchorEl, setAvatarAnchorEl] = useState<null | HTMLElement>(null);
 const [selectedDatabase, setSelectedDatabase] = useState<string>('');
 const { user } = useAuthContext();

 const getDatabasesFromUser = () => {
  if (!user || !user.databases) {
   return ['Cloud2025 (< 1 GB)'];
  }
  const separators = /[;,]/;
  const splitValues = user.databases
   .split(separators)
   .map((database) => database.trim())
   .filter(Boolean);
  if (!splitValues.length) {
   return ['Cloud2025 (< 1 GB)'];
  }
  return splitValues;
 };

 const databasesList = getDatabasesFromUser();

 useEffect(() => {
  const list = getDatabasesFromUser();
  if (!list.length) {
   return;
  }
  if (user && user.currentlyActiveDb && list.includes(user.currentlyActiveDb)) {
   setSelectedDatabase(user.currentlyActiveDb);
   return;
  }
  setSelectedDatabase(list[0]);
 }, [user]);

 const handleAvatarClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  setAvatarAnchorEl(event.currentTarget);
 };

 const handleAvatarPopoverClose = () => {
  setAvatarAnchorEl(null);
 };

 const handleProfileModalClose = () => {
  setProfileModalOpen(false);
 };

 return (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', order: 3 }}>
   <Button
    id="user-menu-button"
    onClick={handleAvatarClick}
    aria-haspopup="true"
    aria-expanded={Boolean(avatarAnchorEl) ? 'true' : undefined}
    aria-label="open user menu"
    variant="text"
    sx={(theme: Theme) => ({
     display: 'flex',
     alignItems: 'center',
     gap: 1,
     px: 1,
     minWidth: 0,
     fontSize: 12,
     color: theme.palette.kemek.darkestGray,
     fontWeight: 'medium',
     textTransform: 'none',
    })}
    endIcon={<IconAngleBottom />}
   >
    <Avatar
     alt="Remy Sharp"
     src={new URL('@assets/user.jpg', import.meta.url).href}
     sx={{ width: 32, height: 32 }}
    />
    <Box sx={{ display: { xs: 'none', md: 'block' }, ml: 1 }}>
     {user?.name || '-'}
    </Box>
   </Button>
   <UserPopover
    open={Boolean(avatarAnchorEl)}
    anchorEl={avatarAnchorEl}
    onClose={handleAvatarPopoverClose}
    onOpenProfile={() => {
     setProfileModalOpen(true);
     handleAvatarPopoverClose();
    }}
    user={user}
    databasesList={databasesList}
    selectedDatabase={selectedDatabase}
    onDatabaseChange={(value) => setSelectedDatabase(value)}
    languages={(languages && Object.keys(languages)) || []}
    currentLanguage={i18n.language}
    onLanguageChange={(lng) => {
     i18n.changeLanguage(lng);
     localStorage.removeItem('structure');
     handleAvatarPopoverClose();
     window.location.reload();
    }}
    onLogout={() => {
     dispatch(identityLogoutStart());
    }}
   />
   <UserProfileModal
    open={profileModalOpen}
    onClose={handleProfileModalClose}
   />
  </Box>
 );
};

function Header({
 isSidebarOpen,
 setIsSidebarOpen,
}: {
 isSidebarOpen: boolean;
 setIsSidebarOpen: Dispatch<SetStateAction<boolean>>;
}) {
 const { mode, setMode } = useColorScheme();
 const theme = useTheme();
 const appVersion = buildversion.trim();
 const navigate = useNavigate();

 return (
  <AppBar
   elevation={0}
   position="fixed"
   sx={{
    height: layoutSizes.headerHeight,
    width: isSidebarOpen
     ? { xs: '100%', md: `calc(100% - ${layoutSizes.sidebarWidth}px)` }
     : { xs: '100%', md: 'calc(100% - 76px)' },
    ml: isSidebarOpen
     ? { xs: '100%', md: `${layoutSizes.sidebarWidth}px` }
     : { xs: '0px', md: '76px' },
    boxShadow: 'none',
    background: theme.palette.kemek.bg2,
    borderBottom: `1px solid ${theme.palette.kemek.lightestGray}`,
   }}
  >
   <Toolbar sx={{ height: '100%' }}>
    <IconButton
     size="large"
     edge="start"
     color="inherit"
     aria-label="menu"
     sx={{ mr: 2, width: 44, height: 44 }}
     onClick={() => setIsSidebarOpen((prevState) => !prevState)}
    >
     <IconNav style={{ color: theme.palette.kemek.darkestGray }} />
    </IconButton>

    {/* <Search /> */}
    <Box
     sx={{
      gap: { xs: '24px', md: '32px' },
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
     }}
    >
     {/* <Box>localStorage: {lsSize()}</Box> */}
     <IconButton
      size="large"
      sx={{ p: '4px', height: 24, display: { xs: 'block', md: 'none' } }}
      edge="start"
      color="inherit"
      aria-label="menu"
     >
      <IconMeter />
     </IconButton>
     {/* <Box
      sx={{
       display: { xs: 'none', md: 'flex' },
       alignItems: 'center',
       gap: '20px',
      }}
     >
      <ScalesWidget />
      <ScalesWidget />
     </Box> */}
     <UserWidget />
     <Box
      sx={{
       display: { xs: 'none', md: 'flex' },
       alignItems: 'center',
       fontSize: 12,
       color: theme.palette.kemek.lightGray,
      }}
     >
      {appVersion || '-'}
     </Box>
     <IconButton
      onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
      size="large"
      sx={{
       p: '0px',
       width: 24,
       height: 24,
       ml: 0,
       display: { xs: 'none', md: 'flex' },
      }}
      edge="start"
      color="inherit"
      aria-label="toggle color mode"
     >
      {mode === 'dark' ? (
       <IconMoon
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      ) : (
       <IconSun
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      )}
     </IconButton>
     <IconButton
      onClick={() => navigate('/admin/dashboard')}
      size="large"
      sx={{
       p: '0px',
       width: 24,
       height: 24,
       ml: 0,
       display: { xs: 'none', md: 'flex' },
      }}
      edge="start"
      color="inherit"
      aria-label="open admin dashboard"
     >
      <IconSettings
       style={{
        color: theme.palette.kemek.darkestGray,
        width: 24,
        height: 24,
       }}
      />
     </IconButton>
    </Box>
   </Toolbar>
  </AppBar>
 );
}
export default Header;
